module.exports = __webpack_public_path__ + "static/img/file-default.e93e99c6.svg";